import React from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import { Welcome } from 'components/common/Welcome/Welcome'
import styles from './AbilityWelcome.module.scss'
import { getRespondent, getGMA } from 'ducks/respondent'
import { toGmaQuizGuide } from 'ducks/router'
import { BoldButton } from 'components/shared/BoldButton/BoldButton'
import { t } from 'ttag'
import EyeIcon from 'assets/icons/eye.svg'

export const AbilityWelcome = ({
  id: uuid,
  totalQuestions,
  toGmaQuizGuide,
  secondsTotal,
}) => {
  return (
    <Welcome
      description={
        <div className={styles.description}>
          <div className={styles.paragraph}>
            {t`The test consists of ${totalQuestions} questions of varying difficulty.`}{' '}
            <b>{t`We recommend that you take the test somewhere quiet and without distractions.`}</b>
          </div>
          <div className={styles.paragraph}>
            {t`Each question has 6 alternative answers and`}{' '}
            <b>{t`only one of them is correct`}</b>.{' '}
            {t`You may skip questions which you cannot answer. They will reappear again at the end.`}
          </div>
          <div className={styles.paragraph}>
            {t`By pressing “See an example” you will see an example of the questions the test consist of.`}
          </div>
        </div>
      }
      totalQuestions={totalQuestions}
      time={`${Math.round(secondsTotal / 60)} ${t`minutes`}`}
      button={
        <BoldButton
          label={t`See an example`}
          icon={EyeIcon}
          isIconFirst
          onClick={() => toGmaQuizGuide({ uuid })}
        />
      }
    />
  )
}

export default connect(R.converge(R.mergeLeft, [getGMA, getRespondent]), {
  toGmaQuizGuide,
})(AbilityWelcome)
